// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"624":"45288bbd","787":"4bd79da3"}[chunkId] + ".chunk.js";
};